import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { NgbAccordion, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { filter, map, switchMap, take, takeWhile, tap } from 'rxjs/operators';
import { LocationRelationship } from 'src/app/admin/location/shared/models/locationRelationship';
import { TextConfigurationService } from 'src/app/admin/text-configuration/shared/services/text-configuration.service';
import { AppInitService } from 'src/app/app-init.service';
import { BusyService } from 'src/app/core/services/busy.service';
import { Globals } from 'src/app/core/services/globals';
import { TenantService } from 'src/app/core/services/tenant.service';
import { getShowLobbyCheckInPopup } from 'src/app/lobby/lobby-check-in/state';
import * as LobbyCheckInPageActions from 'src/app/lobby/lobby-check-in/state/actions/lobby-check-in-page.actions';
import * as LobbyStaffStatusActions from 'src/app/lobby/lobby-staff-status/state/actions/lobby-staff-status.actions';
import { getShowWrapUpPopUp } from 'src/app/lobby/lobby-wrap-up/state';
import * as LobbyWrapUpPageActions from 'src/app/lobby/lobby-wrap-up/state/actions/wrap-up-page.actions';
import { TrasnferdAssistDetail } from 'src/app/lobby/shared/models/lobby-user-signin-status.model';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { UserSigninStatus } from 'src/app/shared/enums/UserSigninStatus.enum';
import { ConfigurationGroup } from 'src/app/shared/enums/configurationGroup.enum';
import { MessageTypeName } from 'src/app/shared/enums/messageType.enum';
import { SystemConfigurationName } from 'src/app/shared/enums/systemConfigurationName.enum';
import { MapSigninStatusWithCurrentAssisting } from 'src/app/shared/mappers/signinstatus.mapper';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { readCastedValue } from 'src/app/shared/utils/read-casted-value.function';
import { State } from 'src/app/state/app.state';
import { UserPermissions } from '../../../enums/permissionType';
import * as CoreActions from './../../../../state/actions/core.actions';
import {
  GetUserPermissionList,
  getACClientConfiguration,
  getACLicenseStatus,
  getAvailableActiveBranches,
  getCurrentTenant,
  getLTLicenseStatus,
  getLobbyLocationSelected,
  getLobbyShowCategory,
  getLoggedInUserId,
  getLoggedInUserInfo,
  getSignedInStatus,
  getSystemConfigurations,
  getTenantLogoUrl,
  getUrlCodeForCurrentTenant
} from './../../../../state/index';
import { ACClientConfiguration } from 'src/app/shared/models/acClientConfiguration';
declare const window: any;
@Component({
  selector: 'app-left-navbar',
  templateUrl: './app-left-navbar.component.html',
  styleUrls: ['./app-left-navbar.component.scss']
})
export class AppLeftNavbarComponent implements OnInit, OnDestroy {

  private acWidgetUrl: string = '';
  private urlCode: string = '';
  public logoUrl: any;
  private appConfig!: AppConfigurations;
  leftNavbarSubscriptions = new Subscription();
  isACLicenseEnabled$: Observable<boolean> = this.store.select(getACLicenseStatus);
  isLTLicenseEnabled$: Observable<boolean> = this.store.select(getLTLicenseStatus);
  public userPermissionList: number[] = [];
  public showAcAppointments: boolean = false;
  public showAcAdministration: boolean = false;
  showLobbyCategory: boolean = false;
  enableTextMessages: boolean = false;
  isAssisting: boolean = false;
  private currentAssistingLocationId: number = 0;
  private currentAssistingLobbyEntryId: number = 0;
  public transferInfoOpened: boolean = false;
  public enableUserImpersonation: boolean = false;
  public enableUserImpersonationForTenant: boolean = false;
  public isImpersonateAssistOtherUser: boolean = false;
  public transferFrom: string = '';
  public isAllowWidgetAppointmentsThroughPortalEnabled: boolean = false;
  public acClientConfiguration: ACClientConfiguration | null = null;
  public activeAcTab: string | null = null;

  public transferAssistDetails: TrasnferdAssistDetail[] = [];
  constructor(
    private router: Router,
    private globals: Globals,
    private store: Store<State>,
    private appInitService: AppInitService,
    private tenantService: TenantService,
    private textConfigurationService: TextConfigurationService, 
    private spinner: BusyService,
    private translationLoaderFacade: TranslationLoaderFacade) 
    {
      this.sidebar_collapsed = globals.sidebar_collapsed;
    }

  // public showLeftNavBar: boolean = true;
  private sidebar_collapsed: boolean;

  public lobbyCheckInOpened = false;
  public lobbyWrapUpOpened = false;
  public showWrapUpButton = false;
  public tenantId = 0;
  public locationId = 0;
  public signInUserId = 0;
  public locationName: string = '';
  public locationTimezone: string = '';
  public transferOpened: boolean = false;
  public userCode: string = ''; 

 @ViewChild('myIframe', { static: true }) iframeRef!: ElementRef<HTMLIFrameElement>;
  @ViewChildren(NgbAccordion) accordions!: QueryList<NgbAccordion>;
 @Output() navigateInsideIframe = new EventEmitter<string>();
  /**
   * FIXME Method too long
   */
  ngOnInit() {
    this.spinner.busy();
    

    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      this.userPermissionList = this.normalizePermissionList(allUserPermissions || []);
      this.showAcAppointments = this.userPermissionList.includes(UserPermissions['View Appointments / Exceptions']);
      this.showAcAdministration = this.findCommonElement(this.userPermissionList, [
        UserPermissions['View/Edit Administration'],
        UserPermissions['View Campaigns']
      ]);
    });
    const appConfigSub = this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => {
        this._onReceiveAppConfig(config);
        this.spinner.idle();
      }
    })

    this.leftNavbarSubscriptions.add(
      this.store.select(getTenantLogoUrl).subscribe(url => this.logoUrl = url)
    );

    this.leftNavbarSubscriptions.add(
      this.store.select(getLobbyShowCategory).subscribe(
        (lobbyCategory) => {
          this.showLobbyCategory = lobbyCategory;

        }
      )
    );

    const tenantSubscriptions = this.store.select(getCurrentTenant).subscribe(
      (tenantInfo) => {
        if (tenantInfo != null) {
          this.tenantId = tenantInfo.tenantID;
        }
      }
    );

    const signinStatusSubscription = this.store.select(getSignedInStatus)
      .subscribe((status: any) => {

        if (status == null) {
          return;
        }
        if (status.statusId == UserSigninStatus.Assisting && status.impersonateById == null) {
          this.isAssisting = true;
        }
        else {
          this.isAssisting = false;
        }
        this.currentAssistingLocationId = status.currentAssistingLocationId;
        this.currentAssistingLobbyEntryId = status.currentAssistingLobbyEntryId;

      });
    const wraupupsubscription = this.store.select(getShowWrapUpPopUp).subscribe(
      wrapUpPopUp => {
        this.showWrapUpButton = wrapUpPopUp.showWrapUpButton;


        if (wrapUpPopUp.openWrapUpPopUp) {
          this.showLobbyWrapUp();
        } else {
          this.closeLobbyWrapUp();
        }
      }
    );
    const userLocationSubscriptions = this.store.select(getLobbyLocationSelected).subscribe(
      (location) => {
        if (location.locationId == null) {
          return;
        }
        this.locationId = location.locationId;
        this.locationName = location.locationName;
        this.locationTimezone = location.timezoneId;
      }
    );
    const userIdSubscriptions = this.store.select(getLoggedInUserId).subscribe(
      (userId) => {
        if (userId !== undefined) {
          this.signInUserId = userId;
        }
      }
    );
    
    const showLobbyCheckInPopupSubscriptions = this.store.select(getShowLobbyCheckInPopup).subscribe(
      (showLobbyCheckIn) => {
        this.lobbyCheckInOpened = showLobbyCheckIn;
      }
    );
    const urlCodeSubs = this.store.select(getUrlCodeForCurrentTenant).subscribe(urlcode => this.urlCode = urlcode);
    const userInfoSubscription = this.store.select(getLoggedInUserInfo).subscribe((userInfo) => {
      if (userInfo != null) {
        this.enableUserImpersonation = userInfo.enableUserImpersonation;
        this.userCode = userInfo.userCode;
      }


    });
    this.leftNavbarSubscriptions.add(
      this.store.select(getSystemConfigurations).subscribe(
        (configurations) => {
          const lobbyConfigurations = configurations.filter(c => c.configurationGroup === ConfigurationGroup.LobbySettings);
          if (lobbyConfigurations.length > 0) {
            const enableUserImpersonationForTenantTemp = readCastedValue(lobbyConfigurations
              .find(ac => ac.configurationName === SystemConfigurationName.EnableUserImpersonation)
            );
            if (typeof enableUserImpersonationForTenantTemp == 'boolean') {
              this.enableUserImpersonationForTenant = enableUserImpersonationForTenantTemp;
            }
          }

          const appointmentConfigurations = configurations.filter(c => c.configurationGroup === ConfigurationGroup.AppointmentSettings);
          if(appointmentConfigurations.length > 0) {
            const allowWidgetAppointmentsThroughPortal = readCastedValue(appointmentConfigurations
              .find(ac => ac.configurationName === SystemConfigurationName.AllowWidgetAppointmentThrough)
            );
            if (typeof allowWidgetAppointmentsThroughPortal == 'boolean') {
              this.isAllowWidgetAppointmentsThroughPortalEnabled = allowWidgetAppointmentsThroughPortal;
            }
          }
        }
      )
    );
    const userSignInStatusSubs = this.store.select(getSignedInStatus).subscribe((status) => {
      if (status != null) {

        this.isImpersonateAssistOtherUser = status.isImpersonateOtherUser || false;
        if (status.impersonationTransferDetails != null && status.impersonationTransferDetails.length > 0) {
          this.transferInfoOpened = true;
          this.transferFrom = status.impersonationTransferDetails[0].transferFromUserName;
          this.transferAssistDetails = status.impersonationTransferDetails;
        }
        else {
          this.transferInfoOpened = false;
        }
      }
    });
    this.leftNavbarSubscriptions.add(tenantSubscriptions);
    this.leftNavbarSubscriptions.add(signinStatusSubscription);
    this.leftNavbarSubscriptions.add(wraupupsubscription);
    this.leftNavbarSubscriptions.add(userLocationSubscriptions);
    this.leftNavbarSubscriptions.add(userIdSubscriptions);
    this.leftNavbarSubscriptions.add(showLobbyCheckInPopupSubscriptions);
    this.leftNavbarSubscriptions.add(urlCodeSubs);
    this.leftNavbarSubscriptions.add(userInfoSubscription);
    this.leftNavbarSubscriptions.add(userSignInStatusSubs);
    
        this.store.select(getACClientConfiguration)
          .pipe(takeWhile(() => this.acClientConfiguration == null))
      .subscribe(ecc => this.acClientConfiguration = ecc);
    
    
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.acWidgetUrl = this.appConfig.ac.appointmentWidegetUrl;
  }

  ngOnDestroy(): void {
    this.leftNavbarSubscriptions.unsubscribe();
  }

  // Router link has been added to the left navbar logo,
  // any additional conditionchecks or statements added to this method
  // wont execute when navigated with the router link
  // statements inside the router guard would be executed
  public goToHome() {
    this.router.navigate(['/dashboard']);
  }

  public goToAdmin() {   
    this.router.navigate(['/admin']);
  }

  public goToACWebWidget() {
    const acWidgetFullUrl = `${this.acWidgetUrl}?urlCode=${this.urlCode}&cby=${this.userCode}`;
    window.open(acWidgetFullUrl, '_blank');
  }

  public goToLT() {
    this.router.navigate(['/lobby']);
  }

  public goToActionCenter() {
    this.router.navigate(['/appointment/actioncenter']);
  }

  public toggleSidebar() {
    this.globals.sidebar_collapsed = !this.globals.sidebar_collapsed;
  }

  /**
 * Initiates the lobby check-in process and updates the UI.
 * Fetches text message configurations and sets `enableTextMessages` accordingly.
 * Dispatches various actions to load lobby details, staff members, and services.
 * Updates `showCheckInPopup` flag in the store based on the availability of branches.
 */
  public showLobbyCheckIn() {

    this.enableTextMessages = false;
    const configs = [MessageTypeName.CheckedInCustomer_WalkIn,
    MessageTypeName.CheckedInCustomer_Appointment,
    MessageTypeName.Customer_NextInQueue];

    for (const configKey of configs) {
      this.textConfigurationService.fetchConfigurationPublic(configKey).subscribe((config) => {
        if (JSON.parse(config.configData).OptIn) {
          this.enableTextMessages = true;
        }
      });
    }

    this._showUnableToCheckinPopup().subscribe(branchesAvailable => {
      if (branchesAvailable) {
        this.store.dispatch(LobbyCheckInPageActions.spanishSpeakerPreferredChange({ spanishSpeakerPreferred: false }));
        this.store.dispatch(LobbyCheckInPageActions.setLocationId({ locationId: this.locationId }));
        this.store.dispatch(LobbyCheckInPageActions.loadLobbyDetails({ locationId: this.locationId }));
        this.store.dispatch(LobbyCheckInPageActions.loadStaffMembers({
          tenantId: this.tenantId,
          locationId: this.locationId,
          showInLobby: true
        }));
        this.store.dispatch(LobbyCheckInPageActions.loadServices({ locationId: this.locationId, showInLobby: true, showCategory: this.showLobbyCategory }));
        this.store.dispatch(LobbyCheckInPageActions.setLobbyCheckInPopupFlag({ showCheckInPopup: true }));
        return;
      }
      this.store.dispatch(LobbyCheckInPageActions.setLobbyCheckInPopupFlag({ showCheckInPopup: branchesAvailable }));
    });
  }

  public closeLobbyCheckIn(openWrapUp: boolean) {
    this.lobbyCheckInOpened = false;
    if (openWrapUp) {
      this.showLobbyWrapUp();
    }
  }

  public showLobbyWrapupBtnClick() {
    this._showSigninPopupIfNotSignedInAlready().subscribe(signedinStatus => {
      if (signedinStatus) {
        this.store.dispatch(LobbyWrapUpPageActions.loadWrapUpPopUp({
          lobbyEntryId: this.currentAssistingLobbyEntryId,
          isImpersonateAssist: false,
          impersonatedByName: '',
          showLobbyCateogory: this.showLobbyCategory,
          impersonatedByCode: ''
        }));
      }
    });
  }

  public showImpersonateTransferBtnClick() {
    this.transferOpened = true;
    this.store.dispatch(LobbyStaffStatusActions.loadImpersonateAssistDetails());
  }

  public showLobbyWrapUp() {
    this._showSigninPopupIfNotSignedInAlready().subscribe(signedinStatus => {
      this.lobbyWrapUpOpened = signedinStatus;
    });
  }

  public closeLobbyWrapUp() {
    this.lobbyWrapUpOpened = false;
  }

  // Shows signin popup if not signed in already and returns the signin status for further actions
  private _showSigninPopupIfNotSignedInAlready(): Observable<boolean> {
    return this.store.select(getSignedInStatus).
      pipe(
        map(MapSigninStatusWithCurrentAssisting),
        take(1), // This would remove the need for the subscriber to unsubscribe
        tap((status) => {
          if (!status.isSignInSuccess) {
            this.store.dispatch(CoreActions.promptUserToSignin({ payload: { isSelectorChange: false } }));
          }
        }),
        switchMap(status => of(status.isSignInSuccess))
      );
  }

  private _showUnableToCheckinPopup(): Observable<boolean> {
    return this.store.select(getAvailableActiveBranches)
      .pipe(
        tap((b: LocationRelationship[]) => {
          if (b.length == 0) this.store.dispatch(CoreActions.promptUnableToCheckin());
        }),
        switchMap(b => of(b.length > 0))
      );
  }

  public closeTransferImpersonateAssists() {
    this.transferOpened = false;
  }

  public get UserPermissions(): typeof UserPermissions {
    return UserPermissions;
  }

  get isUserManagemenLeftMenuEnable(): boolean {
    const userMenuPermissions = [18, 14];
    if (this.userPermissionList != null && this.userPermissionList.length > 0) {
      return this.findCommonElement(this.userPermissionList, userMenuPermissions);
    }
    return false;
  }

  get isLocationServiceLeftMenuEnable(): boolean {
    const locationServicePermissions = [6, 10, 11, 49];
    if (this.userPermissionList != null && this.userPermissionList.length > 0) {
      return this.findCommonElement(this.userPermissionList, locationServicePermissions);
    }
    return false;
  }

  get isConfigurationLeftMenuEnable(): boolean {
    const configurationPermissions = [
      1, 31, 57, 27, 53, 3, 4,67,
      UserPermissions['View/Edit Administration'],
      UserPermissions['View Campaigns']
    ].filter((p): p is number => typeof p === 'number');
    if (this.userPermissionList != null && this.userPermissionList.length > 0) {
      return this.findCommonElement(this.userPermissionList, configurationPermissions);
    }
    return false;
  }

  get isReportLeftMenuEnable(): boolean {
    const reportPermissions = [60, 65,63,83,64];
    if (this.userPermissionList != null && this.userPermissionList.length > 0) {
      return this.findCommonElement(this.userPermissionList, reportPermissions);
    }
    return false;
  }

  public showImpersonateTransferInfoBtnClick() {
    this.transferInfoOpened = true;
  }

  public closeTransferImpersonateAssistsInfo() {
    this.transferInfoOpened = false;
  }

  public hideTransferButton() {
    this.isImpersonateAssistOtherUser = false;
  }

  findCommonElement(array1: number[], array2: number[]) {
    for (const element of array1) {
      for (const element2 of array2) {
        if (element === element2) {
          return true;
        }
      }
    }
    return false;
  }

  private normalizePermissionList(list: (number | string)[]): number[] {
    if (!list) return [];
    const out: number[] = [];
    for (const p of list) {
      if (typeof p === 'number') out.push(p);
      else if (typeof p === 'string') {
        const n = parseInt(p, 10);
        if (!isNaN(n)) out.push(n);
      }
    }
    return Array.from(new Set(out));
  }

  public onPanelChange(event: NgbPanelChangeEvent, sourceAccordion: NgbAccordion | null) {
    try {
      if (!event || !event.nextState) return;
      if (!this.accordions) return;
      this.accordions.forEach(acc => {
        if (sourceAccordion && acc === sourceAccordion) return;
        try { acc.collapseAll(); } catch (e) { /* ignore */ }
      });
    } catch (err) {
      return;
    }
  }

}

